module.exports = __webpack_public_path__ + "static/wonder_woman_1984_4320x1080-mobile.755e0737.png";